import { convertToBooleanValue } from '80.quickConnect.Core/helpers';
import { CheckBoxDesc } from '90.quickConnect.Models/models';

const mapCheckBoxDesc = (field: CheckBoxDesc): CheckBoxDesc => {
  const { defaultValue, isVertical, value } = field;

  const convertedDefault = convertToBooleanValue(defaultValue);
  const convertedValue = convertToBooleanValue(value);

  return {
    value: convertedValue ?? convertedDefault ?? false,
    defaultValue: convertedDefault ?? false,
    isVertical: isVertical,
  } as unknown as CheckBoxDesc;
};

export default mapCheckBoxDesc;
